import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { incidentalLoanService } from '../../services/incidentalLoanService'
import { memberService } from '../../services/memberService'
import api from '../../services/api'
import Swal from 'sweetalert2'

function IncidentalLoanApply() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [members, setMembers] = useState([])
  const [selectedMember, setSelectedMember] = useState(null)
  const [settings, setSettings] = useState(null)
  const memberSelectRef = useRef(null)
  const [formData, setFormData] = useState({
    NBA: '',
    JumlahPinjaman: '',
    Catatan: ''
  })
  const [calculation, setCalculation] = useState(null)
  const [calculating, setCalculating] = useState(false)
  const [coopProfile, setCoopProfile] = useState(null)

  useEffect(() => {
    fetchMembers()
    fetchSettings()
    fetchCoopProfile()
  }, [])

  const fetchCoopProfile = async () => {
    try {
      const response = await api.get('/reports/profile-info')
      setCoopProfile(response.data.data?.coopProfile || response.data.data)
    } catch (error) {
      console.error('Error fetching coop profile:', error)
    }
  }

  const fetchMembers = async () => {
    try {
      const response = await memberService.getAll({
        statusAktif: '1',
        statusAnggota: 'AnggotaPenuh',
        excludeActiveIncidentalLoans: 'true'
      })
      setMembers(response.data.data || [])
    } catch (error) {
      console.error('Error fetching members:', error)
    }
  }

  const fetchSettings = async () => {
    try {
      const response = await incidentalLoanService.getSettings()
      if (response.data.data && response.data.data.length > 0) {
        setSettings(response.data.data[0])
      }
    } catch (error) {
      console.error('Error fetching settings:', error)
    }
  }

  const calculateLoan = async () => {
    if (!formData.JumlahPinjaman || !settings) return

    setCalculating(true)
    try {
      const response = await incidentalLoanService.calculate({
        JumlahPinjaman: formData.JumlahPinjaman,
        JangkaWaktu: settings.JangkaWaktu,
        PersentaseBunga: settings.PersentaseBunga
      })
      setCalculation(response.data.data)
    } catch (error) {
      console.error('Error calculating:', error)
    } finally {
      setCalculating(false)
    }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (formData.JumlahPinjaman > 0 && settings) {
        calculateLoan()
      }
    }, 500)
    return () => clearTimeout(timeout)
  }, [formData.JumlahPinjaman, settings])

  useEffect(() => {
    // Initialize Select2 for member dropdown
    if (memberSelectRef.current && members.length > 0) {
      // Check if Select2 is already initialized
      if ($(memberSelectRef.current).data('select2')) {
        $(memberSelectRef.current).select2('destroy')
      }
      
      // Initialize Select2
      $(memberSelectRef.current).select2({
        placeholder: 'Pilih Anggota',
        allowClear: true,
        width: '100%'
      })

      // Set current value
      if (formData.NBA) {
        $(memberSelectRef.current).val(formData.NBA).trigger('change')
      }

      // Handle change event
      $(memberSelectRef.current).on('change', (e) => {
        const nba = e.target.value
        const member = members.find(m => m.NBA === nba)
        setSelectedMember(member || null)
        setFormData(prev => ({ ...prev, NBA: e.target.value }))
      })
    }

    // Cleanup
    return () => {
      if (memberSelectRef.current && $(memberSelectRef.current).data('select2')) {
        $(memberSelectRef.current).off('change').select2('destroy')
      }
    }
  }, [members])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!settings) {
      Swal.fire({
        icon: 'warning',
        title: 'Peringatan',
        text: 'Pengaturan pinjaman insidentil belum diatur'
      })
      return
    }

    setLoading(true)
    try {
      const response = await incidentalLoanService.apply(formData)
      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: 'Pengajuan pinjaman berhasil dibuat',
        timer: 2000,
        showConfirmButton: false
      }).then(() => {
        navigate(`/incidental-loans/${response.data.data.NoPinjaman}`)
      })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: error.response?.data?.message || 'Gagal membuat pengajuan pinjaman'
      })
    } finally {
      setLoading(false)
    }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(value || 0)
  }

  const handlePrintSchedule = () => {
    if (!calculation || !calculation.jadwalAngsuran) return

    const printWindow = window.open('', '_blank')
    printWindow.document.write(`
      <html>
        <head>
          <title>Simulasi Jadwal Angsuran Pinjaman Insidentil</title>
          <style>
            @page { margin: 15mm; }
            body { font-family: Arial, sans-serif; font-size: 12px; }
            .header { text-align: center; margin-bottom: 20px; }
            .header h3 { margin: 0; font-size: 16px; }
            .info { margin-bottom: 15px; }
            .info table { width: 100%; border-collapse: collapse; }
            .info td { padding: 3px 0; }
            .info .label { width: 150px; font-weight: bold; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #000; padding: 8px; text-align: right; }
            th { background-color: #f0f0f0; font-weight: bold; text-align: center; }
            td:first-child, th:first-child { text-align: center; }
            .footer { margin-top: 20px; font-size: 11px; }
            .sign { margin-top: 30px; display: flex; justify-content: space-between; }
            .sign-box { width: 200px; text-align: center; }
            .sign-line { border-top: 1px solid #000; margin-top: 50px; padding-top: 5px; }
          </style>
        </head>
        <body>
          <div class="header">
            <h3>${coopProfile?.NamaKoperasi || 'KOPERASI'}</h3>
            <p>${coopProfile?.Alamat || ''}</p>
            <h4 style="margin-top: 15px;">SIMULASI JADWAL ANGSURAN PINJAMAN INSIDENTIL</h4>
          </div>
          
          <div class="info">
            <table>
              <tr><td class="label">Nama Anggota</td><td>: ${selectedMember?.Nama || '-'}</td></tr>
              <tr><td class="label">NBA</td><td>: ${selectedMember?.NBA || '-'}</td></tr>
              <tr><td class="label">Plafond</td><td>: ${formatCurrency(calculation.plafond)}</td></tr>
              <tr><td class="label">Tipe Bunga</td><td>: ${calculation.tipeBunga}</td></tr>
              <tr><td class="label">Suku Bunga/Tahun</td><td>: ${calculation.bunga}%</td></tr>
              <tr><td class="label">Tenor</td><td>: ${calculation.tenor} Bulan</td></tr>
            </table>
          </div>
          
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>Angsuran Pokok</th>
                <th>Angsuran Bunga</th>
                <th>Total Angsuran</th>
                <th>Sisa Pokok</th>
              </tr>
            </thead>
            <tbody>
              ${calculation.jadwalAngsuran.map((item, idx) => `
                <tr>
                  <td>${item.angsuranKe}</td>
                  <td>${formatCurrency(item.pokok)}</td>
                  <td>${formatCurrency(item.bunga)}</td>
                  <td>${formatCurrency(item.total)}</td>
                  <td>${formatCurrency(item.sisaPokok)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <div class="footer">
            <p><strong>Keterangan:</strong></p>
            <ul>
              <li>Simulasi ini merupakan perkiraan dan dapat berubah sesuai kebijakan koperasi</li>
              <li>Bunga dihitung berdasarkan sisa pokok per bulan (menurun)</li>
              <li>Pembayaran dapat dilakukan lebih cepat tanpa penalty</li>
            </ul>
          </div>
          
          <div class="sign">
            <div class="sign-box">
              <p>Calon Anggota</p>
              <div class="sign-line">${selectedMember?.Nama || ''}</div>
            </div>
            <div class="sign-box">
              <p>Petugas Koperasi</p>
              <div class="sign-line">..........................</div>
            </div>
          </div>
          
          <div style="text-align: center; margin-top: 30px; font-size: 10px;">
            Dicetak tanggal: ${new Date().toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })}
          </div>
        </body>
      </html>
    `)
    
    printWindow.document.close()
    setTimeout(() => printWindow.print(), 500)
  }

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Pengajuan Pinjaman Insidentil</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="card-body">
              {settings && (
                <div className="alert alert-info">
                  <h6>Informasi Pengaturan:</h6>
                  <ul className="mb-0">
                    <li>Plafon Maksimal: {formatCurrency(settings.Plafon)}</li>
                    <li>Jangka Waktu: {settings.JangkaWaktu} bulan</li>
                    <li>Bunga: {settings.PersentaseBunga}% per tahun</li>
                    <li>Denda: {settings.PersentaseDenda}% per bulan</li>
                  </ul>
                </div>
              )}

              {!settings && (
                <div className="alert alert-warning">
                  Pengaturan pinjaman insidentil belum diatur. Silakan hubungi admin.
                </div>
              )}

              <div className="form-group">
                <label>Anggota <span className="text-danger">*</span></label>
                <select
                  ref={memberSelectRef}
                  className="form-control select2"
                  required
                  disabled={!settings}
                >
                  <option value="">Pilih Anggota</option>
                  {members.map((member) => (
                    <option key={member.NBA} value={member.NBA}>
                      {member.NBA} - {member.Nama}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Jumlah Pinjaman <span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  value={formData.JumlahPinjaman}
                  onChange={(e) => setFormData({ ...formData, JumlahPinjaman: e.target.value })}
                  min="100000"
                  required
                  disabled={!settings}
                  placeholder={`Maksimal: ${settings ? formatCurrency(settings.Plafon) : '-'}`}
                />
                {settings && formData.JumlahPinjaman > settings.Plafon && (
                  <small className="text-danger">
                    Jumlah melebihi plafon maksimal
                  </small>
                )}
              </div>

              <div className="form-group">
                <label>Catatan</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={formData.Catatan}
                  onChange={(e) => setFormData({ ...formData, Catatan: e.target.value })}
                  disabled={!settings}
                />
              </div>
            </div>
            <div className="card-footer">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !settings}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Memproses...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane mr-2"></i>
                    Ajukan Pinjaman
                  </>
                )}
              </button>
              <button
                type="button"
                className="btn btn-default ml-2"
                onClick={() => navigate('/incidental-loans')}
              >
                Batal
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="col-md-6">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Simulasi Perhitungan</h3>
          </div>
          <div className="card-body">
            {calculating ? (
              <div className="text-center py-3">
                <i className="fas fa-spinner fa-spin"></i>
                <p className="mt-2">Menghitung...</p>
              </div>
            ) : calculation ? (
              <div>
                <div className="row mb-3">
                  <div className="col-6">
                    <small className="text-muted">Angsuran Pokok</small>
                    <h5>{formatCurrency(calculation.angsuranPokok || calculation.jadwalAngsuran[0]?.pokok)}</h5>
                  </div>
                  <div className="col-6 text-right">
                    <small className="text-muted">Angsuran Bunga</small>
                    <h5>{formatCurrency(calculation.angsuranBunga || calculation.jadwalAngsuran[0]?.bunga)}</h5>
                  </div>
                </div>
                <div className="alert alert-success text-center">
                  <small className="text-muted">Total Angsuran per Bulan</small>
                  <h4>{formatCurrency(calculation.totalAngsuran || calculation.jadwalAngsuran[0]?.total)}</h4>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                  <h6 className="mb-0">Jadwal Angsuran ({settings?.JangkaWaktu || calculation.tenor} Bulan)</h6>
                  <button 
                    className="btn btn-sm btn-info"
                    onClick={handlePrintSchedule}
                    disabled={!calculation?.jadwalAngsuran?.length}
                  >
                    <i className="fas fa-print mr-1"></i> Cetak Jadwal
                  </button>
                </div>
                <div className="table-responsive" style={{ maxHeight: '400px', overflow: 'auto' }}>
                  <table className="table table-sm table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>Ke</th>
                        <th>Pokok</th>
                        <th>Bunga</th>
                        <th>Total</th>
                        <th>Sisa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(calculation.jadwalAngsuran) && calculation.jadwalAngsuran.map((item) => (
                        <tr key={item.angsuranKe}>
                          <td>{item.angsuranKe}</td>
                          <td className="text-right">{formatCurrency(item.pokok)}</td>
                          <td className="text-right">{formatCurrency(item.bunga)}</td>
                          <td className="text-right">{formatCurrency(item.total)}</td>
                          <td className="text-right">{formatCurrency(item.sisaPokok)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center py-5 text-muted">
                <i className="fas fa-calculator fa-3x mb-3"></i>
                <p>Masukkan jumlah pinjaman untuk melihat simulasi</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default IncidentalLoanApply
